<template>
  <div class="top">
    <div class="clearfix inner">
      <span class="fl">打造中国实用超值的智慧教育应用平台</span>
      <div class="fr navtop">
        <!-- <span @click="$router.push('/')">登录</span> -->
        <!-- <span @click="$router.push('/register')">注册</span> -->
        <span @click="$router.push('/schoolserve')" v-if="!school"
          >开通学校服务</span
        >
        <span
          :class="{ yangshi: this.$route.path == '/helpcenter' }"
          @click="$router.push('/helpcenter')"
          >帮助中心</span
        >
        <span
          
          @click="handelGo"
          >客户反馈</span
        >
        <!-- :class="{ yangshi: show == true }" -->
        <span>
          <!-- 网站导航 -->
          <el-popover placement="bottom" trigger="click">
            <ul>
              <li
                v-for="item in data"
                :key="item.id"
                @click="path(item)"
                class="butdata"
              >
                <a :href="item.net" style="color: #606266" target="_blank">{{
                  item.name
                }}</a>
              </li>
            </ul>
            <div></div>
            <el-button slot="reference" @click="show = true"
              >网站导航</el-button
            >
          </el-popover>
        </span>
        <span>
          <!-- 旗下产品 -->
          <el-popover placement="bottom" trigger="click" width="280">
            <div class="clearfix product">
              <div class="fl">
                <ul class="left">
                  <li
                    v-for="(item, index) in data2"
                    :key="index"
                    :class="{ active: index == num }"
                    @click="toggin(index)"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </div>

              <div class="fl">
                <div class="right">
                  <ul
                    v-for="item in data1"
                    :key="item.id"
                    v-show="item.id == num"
                  >
                    <p>{{ item.title }}</p>
                    <li v-for="(res, index) in item.children" :key="index">
                      <a
                        :href="res.net"
                        style="color: #606266"
                        target="_blank"
                        >{{ res.name }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <el-button slot="reference">旗下产品</el-button>
          </el-popover>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      school: "",
      show: false,
      data: [
        { id: 1, name: "孺教网官网", net: "http://www.rujiaowang.net/" },
        { id: 2, name: "山东大课堂官网", net: "http://sddkt.net/" },
        // { id: 3, name: "孺教网门户网站" },
      ],
      data2: [{ title: "智慧教育设备" }, { title: "智慧教育应用" }],
      data1: [
        {
          title: "学习平板",
          id: 0,
          children: [
            { name: "一生E本E66" , net: "https://item.taobao.com/item.htm?spm=a230r.1.14.256.173a68e3izNiYx&id=634487684954&ns=1&abbucket=17#detail"},
            { name: "一生E本E60" , net: "https://item.taobao.com/item.htm?spm=a1z10.5-c-s.w4002-23365076918.23.1fb679aclHMkMj&id=635928346721"},
            { name: "一生E本E30 Pro", net: "https://item.taobao.com/item.htm?spm=a1z10.5-c-s.w4002-23365076918.16.1fb679aclHMkMj&id=634198511124" },
            // { name: "AF99学习平板" },
            // { name: "AF99学习平板电脑" },
          ],
        },
        {
          title: "教育应用",
          id: 1,
          children: [
            { name: "孺教网网校", net: "http://portal.rujiaowang.net/" },
            {
              name: "孺教云资源平台",
              net: "http://www.rujiaowang.net/edu/rujiaoyun/#/home",
            },
          ],
        },
        // { title: "教育应用", id: 1, children: [{ name: "孺教云资源平台" }] },
      ],
      num: 0,
      id:null,
    };
  },
  watch: {},
  mounted() {
    this.school = localStorage.getItem("school");
    
  },
  methods: {
    path(item) {
      // console.log(item.name);
    },
    toggin(val) {
      this.num = val;
    },
    handelGo(){
      this.id = JSON.parse(localStorage.getItem("info")).user_id;
      window.open(`http://portal.rujiaowang.net/portal/index/tousu?item_id=55&type=workbench&user_id=${this.id}`)
    }
  },
};
</script>

<style lang='less' scoped>
.top {
  background-color: #409eff;
  color: #fff;
  font-size: 14px;
  border: none;
  span {
    display: inline-block;
    padding: 0 15px;
    line-height: 26px;
  }
  .navtop {
    cursor: pointer;
  }
  .yangshi {
    background-color: #fff !important;
    color: #409eff !important;
  }
  /deep/ .el-button {
    border: none;
    background-color: #409eff;
    color: #fff;
    padding: 0;
  }
}
.butdata {
  cursor: pointer;
  text-align: center;
  line-height: 28px;
  font-size: 14px;
}
.active {
  color: #409eff;
}
.product {
  .left {
    padding: 15px;
    li {
      line-height: 28px;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .right {
    // min-height: 150px;
    border-left: 1px solid red;
    padding: 15px 18px;
    ul {
      line-height: 28px;
      p {
        font-size: 14px;
        font-weight: 700;
      }
      li {
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
}
</style>
